
import React from 'react';

const Contact = () => (
  <div className="page_wrapper">
    <h2>Contact Us</h2>
    <p>This is the Contact page. Content coming soon.</p>
  </div>
);

export default Contact;
